const ADP_REFERRAL_STORAGE_KEY = 'adp_referral_submit';

// The original ADP page shipped before referrals were scoped per product, so 'adp'
// keeps the unsuffixed key — customers who already submitted there stay marked as
// submitted rather than being offered the CTA (and ADP a duplicate lead) a second time.
const LEGACY_PRODUCT_ID = 'adp';

export function getAdpReferralStorageKey(businessEntityUuid, productId = LEGACY_PRODUCT_ID) {
  if (productId === LEGACY_PRODUCT_ID) {
    return `${ADP_REFERRAL_STORAGE_KEY}:${businessEntityUuid}`;
  }

  return `${ADP_REFERRAL_STORAGE_KEY}:${productId}:${businessEntityUuid}`;
}

export function isAdpReferralSubmitted(businessEntityUuid, productId) {
  if (!businessEntityUuid || typeof window === 'undefined') {
    return false;
  }

  return Boolean(localStorage.getItem(getAdpReferralStorageKey(businessEntityUuid, productId)));
}

export function setAdpReferralSubmitted(businessEntityUuid, productId) {
  if (!businessEntityUuid || typeof window === 'undefined') {
    return;
  }

  localStorage.setItem(getAdpReferralStorageKey(businessEntityUuid, productId), 'true');
}
